import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ModalidadCalificacion} from '../_models/modalidad-calificacion';

@Injectable({
  providedIn: 'root'
})
export class ModalidadCalificacionService {

  private rutServicioModalidadCalificacion = AppSettings.rutServiciosAPL + '/api/modalidadesCalificaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoModalidadesCalificaciones() {
    return this.httClient.get( this.rutServicioModalidadCalificacion ).pipe( map( res => res as ModalidadCalificacion[] ) );
  }

  listadoModalidadesCalificacionesHabilitadas() {
    return this.httClient.get( this.rutServicioModalidadCalificacion + '/enabled' ).pipe( map( res => res as ModalidadCalificacion[] ) );
  }

  listadoModalidadesCalificacionesIdModalidad(id: string) {
    return this.httClient.get( this.rutServicioModalidadCalificacion + '/modalidad/' + id ).pipe( map( res => res as ModalidadCalificacion[] ) );
  }
  listadoModalidadesCalificacionesHabilitadasIdModalidad(id: string) {
    return this.httClient.get( this.rutServicioModalidadCalificacion + '/modalidad/' + id + '/enabled' ).pipe( map( res => res as ModalidadCalificacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioModalidadCalificacion + '/' + id ).pipe( map( res => res as ModalidadCalificacion ) );
  }

  crear( modalidadCalificacion: ModalidadCalificacion ) {
    modalidadCalificacion.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioModalidadCalificacion, modalidadCalificacion ).pipe( map( res => res as ModalidadCalificacion ) );
  }

  actualizar( modalidadCalificacion: ModalidadCalificacion ) {
    modalidadCalificacion.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioModalidadCalificacion, modalidadCalificacion ).pipe( map( res => res as any ) );
  }


}
